import {
    GET_DELIVERY_PERSON,
    SINGLE_DELIVERY_PERSON,
    LOG_OUT,
    ADD_DELIVERY_PERSON
  } from "../../types";
    
  const initialState = {
    get_all_deliveryPerson: [],
    single_person_info: {},
    add_new_deliveryPerson: {},
    
  };
   
  export default function (state = initialState, action) {
    switch (action.type) {
      case GET_DELIVERY_PERSON:
        return {          
          ...state,
          get_all_deliveryPerson: action.payload,
        };
    case SINGLE_DELIVERY_PERSON:
        return {
            ...state,
            single_person_info: action.payload,
        };
    case ADD_DELIVERY_PERSON:
      return {
        ...state,
        add_new_deliveryPerson:action.payload,
      };
    
      case LOG_OUT: {
        return {
          ...state,
          get_all_deliveryPerson: [],
          single_person_info: {},
          add_new_deliveryPerson:{},
        };
      }
      default:
        return state;
    }
  }
  